import { Box } from "@mui/material";
import { MessagesList } from "../../message";
import { ChatInput } from "./chat-input";

type ChatProps = {
  isEmbedded?: boolean;
};

export const Chat = ({ isEmbedded = false }: ChatProps) => {
  if (isEmbedded) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        <MessagesList />
        <ChatInput isEmbedded={isEmbedded} />
      </Box>
    );
  } else {
    return (
      <>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            width: "80%",
            mx: "auto",
            position: "relative",
            pb: "146px",
            pt: "64px",
          }}
        >
          <MessagesList />
        </Box>
        <ChatInput isEmbedded={isEmbedded} />
      </>
    );
  }
};
